import React, { ComponentType } from "react";
import { IntlProvider } from "react-intl";

import { DEFAULT_LOCALE } from "common/static/regions";

import { getLocale } from "features/common/localisation/utils";

import dictionaries from "./dictionaries";

export default function withLocalisationProvider(Component: ComponentType<{}>) {
  const locale = getLocale();

  return function () {
    return (
      <IntlProvider
        locale={locale}
        messages={dictionaries[locale]}
        defaultLocale={DEFAULT_LOCALE}
      >
        <Component />
      </IntlProvider>
    );
  };
}
